import { motion } from 'framer-motion'; // Import motion from Framer Motion
import aboutimage from "./faq.png"
import { useState } from 'react';
function FaqHero() {
    const [activeIndex, setActiveIndex] = useState(null);
    const faqs = [
        {
            question: "How can Freight Insurance Data help our agency better sell and organize leads? ",
            answer: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."
        },
        {
            question: "What is the onboarding process like with Freight Insurance Data? ",
            answer: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."
        },
        {
            question: "Is the software only geared to agents selling transportation insurance?  ",
            answer: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."
        },
        {
            question: "Does Freight Insurance Data have a training process associated with the software? ",
            answer: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."
        },
    
        // Add more FAQs as needed
    ];

    const handleAccordionClick = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    return (
        <>
            <div className="containerwidth">
                <div className="faqsection" >
                    <motion.div
                        className='heading_section_about'
                        initial={{ x: -100, opacity: 0 }} // Initial position (left side of the screen)
                        animate={{ x: 0, opacity: 1 }} // Animation to move to the center and become visible
                        transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
                    >

                        <p className='aboutmini'>FAQ</p>
                        <h4 className='aboutusheading'>
                            Frequently Asked <br /> Questions
                        </h4>
                        <p className='aboutuspera faqpara'>
                        Have a question not listed below, no problem!   <br></br>
                        Reach out via email or phone, and our team will guarantee a response within 24 business hours. </p>

                        <div className='contactbuttons'>
                            <div className='phonenumberbox ' style={{paddingRight:'40px'}}>
                                <div className='phone'>Phone</div>
                                <div className='exactnumber'>(301) 591-6550</div>
                            </div>
                            <div className='phonenumberbox'>
                                <div className='phone'>E-mails</div>
                                <div className='exactnumber'>support@freightinsdata.com</div>
                            </div>
                        </div>
                    </motion.div>
                    <motion.div
                        className="imgsection"
                        initial={{ x: '100%', opacity: 0 }} // Initial position (right side of the screen)
                        animate={{ x: 0, opacity: 1 }} // Animation to move to the center and become visible
                        transition={{ duration: 0.5, delay: 0.8 }} // Animation duration and delay
                        style={{width:'50%'}}
                    >

                        <img src={aboutimage} alt="" className='' width='100%' />
                    </motion.div>
                    <div className='contactbuttons2 d-none'>
                            <div className='phonenumberbox'>
                                <div className='phone'>Phone</div>
                                <div className='exactnumber'>(301) 591-6550</div>
                            </div>
                            <div className='phonenumberbox'>
                                <div className='phone'>E-mail</div>
                                <div className='exactnumber'>support@freightinsdata.com</div>
                            </div>
                        </div>
                </div>
            </div>
            <div className='containerwidth'>
                <div className='mainheadingfaq '>
                <div className='headingfaq'>FAQ's</div>
                <p className='paraforfaq'>Here are our frequently asked questions. If you have any other queries not covered here, don't hesitate to contact us at support@freightinsdata.com</p>
                </div>
                <div className='mainheadingfaq2 d-none '>
                <div className='headingfaq2'>Frequently asked <br />questions</div>
                <p className='paraforfaq2'>Can’t find the answer here? Check out <br /> our help center.</p>
                </div>
                
                <div className="reviewcontainer formobilbot" style={{ marginTop: "71px" }}>
                    <div className="accordioncus">
                        {faqs.map((faq, index) => (
                            <div className="accordion-item rounded-4" key={index}>
                                <h2 className="accordion-header" id={`heading${index}`}>
                                    <button
                                        className="accordion-button "
                                        type="button"
                                        onClick={() => handleAccordionClick(index)}
                                        aria-expanded={activeIndex === index}
                                        aria-controls={`collapse${index}`}
                                    >
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="arroww" >
                                                {faq.question}
                                            </div>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="#374147" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>

                                    </button>
                                </h2>
                                <div
                                    id={`collapse${index}`}
                                    className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
                                    aria-labelledby={`heading${index}`}
                                    data-bs-parent="#accordionExample"
                                >
                                    <div className="accordion-body">
                                         {faq.answer}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
             
            </div>
        </>
    )
}
export default FaqHero;